import "./helpers/sentry";
import "./helpers/partneroLanding";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ScrollToTop from "./components/scrollTop";

import store from "./reducers";
import { setStore } from "./api/client";
import ErrorBoundary from "./containers/errorBoundary";
import "./styles/normalize.css";
import "./styles/index.css";
import "./styles/grid.css";
import "./styles/stripeInputs.css";
import "./i18n";
import Routes from "./routes";
import DebugSupportPanel from "./components/debugSupportPanel";
import { loadAnalyticsTags } from "./helpers/analyticsTags";

// GTM and gtag.js load only in a build that names them (production); see helpers/analyticsTags.js.
loadAnalyticsTags();
setStore(store);

const AppShell = () => (
  <ErrorBoundary>
    <ScrollToTop />
    <Routes />
    <DebugSupportPanel />
  </ErrorBoundary>
);

// Data router is required for useBlocker (listing unsaved-changes guard). The
// splat keeps the existing nested <Routes> tree mounted for every path.
const router = createBrowserRouter([{ path: "*", element: <AppShell /> }]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <RouterProvider router={router} />
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>
);
